import React from 'react';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import ExecutiveCharts from "../../../../../components/Containers/ExecutiveCharts";
import Select from "react-select";
import Types from "../../../../../constants/Types";
import {Button, ButtonGroup} from "reactstrap";
import {Tooltip} from "@material-ui/core";
import {Collections, Parts} from "../../../../../components";

const breadcrumbStatic = [{
	name: 'FE Comparison',
	url: '/executives/comparison',
	icon: 'dashboard'
}];

export default class ExecutiveChartsContainer extends Framework.Components.View {
	constructor(props) {
		super(props);
		this.state.selectedUsers = [];
		this.state.users = [];
		this.state.filterPeriod = '7 days';
		this.state.forceRefresh = Math.random();
		this.state.selectedRegions = []
		this.state.regions = [];
		this.state.showCharts = false;
		this.state.lastTriggered = null;
		this.interval = null;
	}

	checkTime = () => {
		const now = new Date();
		const minutes = now.getMinutes();
		const seconds = now.getSeconds();

		if ([0, 15, 30, 45].includes(minutes) && seconds === 0) {
			if (this.state.lastTriggered !== minutes) {
				this.setState({ lastTriggered: minutes });
			}
		}
	};

	async componentDidMount() {
		await this.getUsers();
		await this.getRegions();
		this.interval = setInterval(this.checkTime, 1000); // Check every second
	}

	componentWillUnmount() {
		clearInterval(this.interval); // Cleanup on unmount
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
		return this.state.regions;
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		userModel.limit = 500;
		try {
			this.users = await userModel.submit(null, "GET_FIELD_ENGINEERS");
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];

			this.setState({
				users: this.users
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleUsers = async (value) => {
		let users = [];
		if (value) {
			for (let i = 0; i < value.length; i++) {
				users.push(value[i]);
			}
			this.setState({selectedUsers: users})

		} else {
			this.setState({selectedUsers: []})
		}
	}

	render() {
		let {history} = this.props;
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={'col-4'}>
						<Parts.RegionSelectToggle
							parent={this}
							handleRegionsCallback={() => {
								const usersInRegion = this.state.users.filter((user) => this.state.selectedRegions.map((region) => region.value).includes(user.region)).map(user => {
									return (
										{value: user.pkey, label: user.name_first + " " + user.name_last}
									)
								})
								this.setState({selectedUsers: usersInRegion})
							}}
							multi={true}
							noCycle={false}
						/>
					</div>
					<div className={'col-3'} style={{zIndex: 999}}>
						<Select
							key={this.state.selectedUsers}
							placeholder={"Engineer Select"}
							isMulti
							isClearable
							value={this.state.selectedUsers.map(user => {
								return (
									{value: user.value, label: user.label})
							})}
							onChange={this.handleUsers}
							options={this.state.users.map(user => {
								return (
									{value: user.pkey, label: user.name_first + " " + user.name_last})
							})}
						/>
					</div>

					<div className={'col-3'}>
						<ButtonGroup size={"md"}>
							<Button
								onClick={() => {
									this.setState({filterPeriod: '7 days'})
								}}
								outline={this.state.filterPeriod !== '7 days'}
								active={this.state.filterPeriod === '7 days'}
								color={'primary'}
							>
								7 Day
							</Button>
							<Tooltip title={"4 Weeks"} placement={'top'}>
								<Button
									onClick={() => {
										this.setState({filterPeriod: '28 days'})
									}}
									outline={this.state.filterPeriod !== '28 days'}
									active={this.state.filterPeriod === '28 days'}
									color={'primary'}
								>
									1 Month
								</Button>
							</Tooltip>
							<Tooltip title={"12 Weeks"} placement={'top'}>
								<Button
									onClick={() => {
										this.setState({filterPeriod: '84 days'})
									}}
									outline={this.state.filterPeriod !== '84 days'}
									active={this.state.filterPeriod === '84 days'}
									color={'primary'}
								>
									3 Month
								</Button>
							</Tooltip>
							<Tooltip title={"24 Weeks"} placement={'top'}>
								<Button
									onClick={() => {
										this.setState({filterPeriod: '168 days'})
									}}
									outline={this.state.filterPeriod !== '168 days'}
									active={this.state.filterPeriod === '168 days'}
									color={'primary'}
								>
									6 Month
								</Button>
							</Tooltip>
						</ButtonGroup>
					</div>
					<div className={'col-1'}>
						<ButtonGroup>
							<Button
								onClick={() => {
									this.setState({showCharts: true})
								}}
								outline={!this.state.showCharts}
								active={this.state.showCharts}
								color={'primary'}>
								Charts
							</Button>

							<Button
								onClick={() => {
									this.setState({showCharts: false})
								}}
								outline={this.state.showCharts}
								active={!this.state.showCharts}
								color={'primary'}>
								Table
							</Button>
						</ButtonGroup>
					</div>
					<div className={'col d-flex justify-content-end align-items-start'}>
						<div className={'rbc-toolbar'}>
							<button className="rbc-today" type="button" onClick={async () => {
								this.setState({forceRefresh: Math.random()})
							}}>Refresh
							</button>
						</div>
					</div>
				</div>

				{this.state.showCharts ?
					<div className={'flex flex-row h-100 w-100'}>
						<b>Dates are in DD/MM/YYYY format!</b>

						<ExecutiveCharts history={history} selectedUsers={this.state.selectedUsers.map((user) => user.value)}
						                 filterPeriod={this.state.filterPeriod} forceRefresh={this.state.forceRefresh} lastTriggered={this.state.lastTriggered}/>
					</div> : <Collections.ExecutiveCharts history={history} selectedUsers={this.state.selectedUsers.map((user) => user.value)}
					                                      filterPeriod={this.state.filterPeriod} forceRefresh={this.state.forceRefresh} lastTriggered={this.state.lastTriggered}/>}


			</div>
		)
	}
}